module.exports = __webpack_public_path__ + "assets/772b9ff2df876c2096047dd63654901b.png";